import { css, styled } from 'styled-components'

import { MultiLineWithEllipsis } from '@b-stock/fe-core/bstock-next/components'
import { Colors, Typography } from '@b-stock/fe-core/design-system'

import type { SearchResult } from '@/queries/listingSearchQuery'

import { SkeletonTextLine } from '../../ListingCardSkeleton/ui'

const maxLines = 3

const containerCss = css`
  width: 100%;
  ${Typography.Body3}
  color: ${Colors.Semantic.Neutral.black};
`
const TitleContainer = styled(MultiLineWithEllipsis)`
  ${containerCss}
`

const SkeletonTitleLines = styled.div`
  ${containerCss}
`

const Title = ({ listing }: { listing: SearchResult }) => {
  return (
    <TitleContainer maxLines={maxLines} data-testid="listing-title">
      {listing.title}
    </TitleContainer>
  )
}

export default Title

export const TitleSkeleton = () => (
  <SkeletonTitleLines>
    {Array.from({ length: maxLines }).map((_, index) => {
      const key = `title-${index}`
      return <SkeletonTextLine key={key} width="100%" testIdSuffix={key} />
    })}
  </SkeletonTitleLines>
)
